class Package {
    public configurationId?: string;
    public productId: number;
    public product?: string;
    public periodId: number;
    public period?: string;
    public description?: string;
    public price?: string;
    public periods: simpleStruct[];
    public options: string[];
    public professional?: boolean;
    public totalPrice: number;

    constructor(
        productId?: number,
        product?: string,
        periodId?: number,
        period?: string,
        description?: string,
        price?: string,
        professional?: boolean,
        totalPrice?: number
    ) {
        this.configurationId = undefined;
        this.productId = productId || -1;
        this.product = product || undefined;
        this.periodId = periodId || -1;
        this.period = period || undefined;
        this.description = description || undefined;
        this.price = price || undefined;
        this.periods = [];
        this.options = [];
        this.professional = professional || false;
        this.totalPrice = totalPrice || 0;
    }

    static from(json: any) {
        return Object.assign(new Package(), json);
    }
}

export default Package;
